import {
  EMetadataPageType,
  EMetadataSportsType,
  IMetadata,
} from '@/app/models/metadata.model';
import { ESportsApiV1 } from '@/app/models/sports.model';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, of } from 'rxjs';
import { FsApiService } from '../auth/fs-api.service';
import { SportsService } from '../sport.service';
import { TranslationService } from '../translation.service';
import { SeoService } from './seo.service';

@Injectable({
  providedIn: 'root',
})
export class MetadataSportService {
  private fsApi = inject(FsApiService);
  private translationService = inject(TranslationService);
  private sportsService = inject(SportsService);
  private seoService = inject(SeoService);

  constructor() {}

  isLoadingMetadata = signal<boolean>(false);
  isErrorMetadata = signal<boolean>(false);
  metadataList = signal<IMetadata[] | null>(null);
  selectedMetadata = signal<IMetadata | null>(null);

  getMetadataList(callback?: (metadataList: IMetadata[]) => void) {
    this.isLoadingMetadata.set(true);
    this.isErrorMetadata.set(false);

    this.fsApi
      .get<IMetadata | null>(`/metadata/home`, {
        params: {
          language: this.translationService.getLangLocalStorage(),
        },
      })
      .pipe(
        catchError((_) => {
          this.isLoadingMetadata.set(false);
          this.isErrorMetadata.set(true);

          return of(null);
        })
      )
      .subscribe((data: any) => {
        if (!data) {
          this.metadataList.set(null);
          return;
        }

        this.metadataList.set(data.MetadataList as IMetadata[]);
        callback && callback(data.MetadataList as IMetadata[]);
        this.isLoadingMetadata.set(false);
        this.handleMetadataBySport(data.MetadataList as IMetadata[]);
      });
  }

  handleMetadataBySport(metadataList: IMetadata[]) {
    // if (this.metadataList() === null || this.metadataList.length === 0) {
    //   return;
    // }
    const selectedSport = this.sportsService.getSelectedSport();

    const findeMedataBySport = metadataList.find(
      (elem) => elem.Sport === this.handleTypeSport(selectedSport)
    );

    if (findeMedataBySport) {
      this.updatedMetadataBySport(findeMedataBySport);
      this.selectedMetadata.set(findeMedataBySport);
    } else {
      this.selectedMetadata.set({
        Description:
          'Los resultados de la página de fútbol en vivo de Marcadores247 le ofrece los últimos resultados de fútbol para un sin fin de ligas y torneos de todo el mundo, incluyendo estadísticas, partidos de hoy, noticias, tabla de clasificaciones, calendario de partido y retransmisiónes en directo actualizadas en vivo.',
        Id: '',
        PageType: EMetadataPageType.HOME,
        Sport: EMetadataSportsType.FOOTBALL,
        Title: 'Resultados en vivo y partidos hoy en Marcadores247.com',
      });
      this.updatedMetadataBySport({
        Description:
          'Los resultados de la página de fútbol en vivo de Marcadores247 le ofrece los últimos resultados de fútbol para un sin fin de ligas y torneos de todo el mundo, incluyendo estadísticas, partidos de hoy, noticias, tabla de clasificaciones, calendario de partido y retransmisiónes en directo actualizadas en vivo.',
        Id: '',
        PageType: EMetadataPageType.HOME,
        Sport: EMetadataSportsType.FOOTBALL,
        Title: 'Resultados en vivo y partidos hoy en Marcadores247.com',
      });
    }
  }

  handleTypeSport(sport: ESportsApiV1) {
    switch (sport) {
      case ESportsApiV1.FOOTBALL:
        return EMetadataSportsType.FOOTBALL;

      case ESportsApiV1.BASKETBALL:
        return EMetadataSportsType.BASKETBALL;
      case ESportsApiV1.BASEBALL:
        return EMetadataSportsType.BASEBALL;
      case ESportsApiV1.VOLLEYBALL:
        return EMetadataSportsType.VOLLEYBALL;
      case ESportsApiV1.HOCKEY:
        return EMetadataSportsType.ICE_HOCKEY;
      case ESportsApiV1.HANDBALL:
        return EMetadataSportsType.HANDBALL;
      case ESportsApiV1.AMERICAN_FOOTBALL:
        return EMetadataSportsType.AMERICAN_FOOTBALL;

      default:
        return '';
    }
  }

  updatedMetadataBySport(metadataBySport: IMetadata) {
    this.seoService.updateTitle(metadataBySport.Title);
    this.seoService.updateDescription(metadataBySport.Description);
  }
}
